
import * as fromModel from '../models/common-model';
export class Constant {
   
    //Initialization
    static config: any = {};
    static uri = {
        advisorHierarchy:'',
        getEmployeeTree: '',
        getemployeeCertificationDetails:'',
        getSupervisionSmry: '',
        reportItemCt: '',
        supervisionActs: '',
        getSupervisionItems: '',
        saveSupervisionReponse: '',
        uploadFile: '',
        getRefSupervisionQuestionnaire: '',
        downloadFile: '',
        getCrmAccessToken: '',
        getCrmContacts: '',
        getCrmOwner: '',
        getCrmAccounts: '',
        getCrmInteraction: '',
        getColorSelection: '',
        refAccountsSecurities: ''
    };

    static routes = {
        home: 'SupervisionReportHome',
       
    };

    static updateConfig = ((configvalues: any) => {

        Constant.config.clientId = configvalues.clientid;
        Constant.config.instance = configvalues.instance;
        Constant.config.tenant = configvalues.tenant;
        Constant.config.appInsightKey = configvalues.appinsightkey;
        Constant.config.scope = configvalues.scope;
        Constant.config.scopes = configvalues.scope.split(',');
        Constant.config.autority = configvalues.instance + configvalues.tenant;
        Constant.config.superUsers = configvalues.superusers ? (<string>configvalues.superusers).toLocaleUpperCase().split(',') : [];
        Constant.config.pptUrl = configvalues.ppturl;
        Constant.config.compusers = configvalues.compusers ? (<string>configvalues.compusers).toLocaleUpperCase().split(',') : [];
        Constant.config.nfsreportenable = configvalues.nfsreportenable ? configvalues.nfsreportenable : "N";
        Constant.config.env = configvalues.env;
        Constant.config.latestMonth = configvalues.latestmonth;
        Constant.config.latestYr = configvalues.latestyr;
        Constant.config.apiBaseUrl = configvalues.apibaseurl;
        Constant.config.apiEnvUrl = configvalues.apienvurl;
        Constant.config.dynamicCrmBaseUrl = configvalues.dynamiccrmbaseurl;
        Constant.uri.advisorHierarchy = `${Constant.config.apiBaseUrl}Advisors/AdvisorHirerarchy`;
        Constant.uri.getSupervisionSmry = `${Constant.config.apiBaseUrl}SupervisionSmry/SupervisionSmry`;
        Constant.uri.reportItemCt = `${Constant.config.apiBaseUrl}PredefinedReports/ReportItemCount`;
        Constant.uri.supervisionActs = `${Constant.config.apiBaseUrl}AccountSummary/search`;
        Constant.uri.getSupervisionItems = `${Constant.config.apiBaseUrl}Supervision/GetSupervisionReviewItems`;
        Constant.uri.saveSupervisionReponse = `${Constant.config.apiBaseUrl}Supervision/SaveSupervisionReviewResponse`;
        Constant.uri.uploadFile = `${Constant.config.apiEnvUrl}OrderEntry/api/document/uploadfile`;
        Constant.uri.getRefSupervisionQuestionnaire = `${Constant.config.apiBaseUrl}Supervision/GetRefSupervisionQuestionnaire`;
        Constant.uri.downloadFile = `${Constant.config.apiEnvUrl}OrderEntry/api/document/downloadfile`;
        Constant.uri.getCrmAccessToken = `${Constant.config.dynamicCrmBaseUrl}.default`; 
        Constant.uri.getCrmContacts = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/contacts`;    
        Constant.uri.getCrmAccounts = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/accounts`;
        Constant.uri.getCrmInteraction = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/aka_meetingnotes`;
        Constant.uri.getCrmOwner = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/systemusers`;
        Constant.uri.getColorSelection = `${Constant.config.apiBaseUrl}Supervision/GetColorSelection`;
        Constant.uri.refAccountsSecurities = `${Constant.config.apiBaseUrl}Admin/RefAccountsSecurities`;// this is Admin endpoint
    });
}
